import React from 'react';
import { shape, string, func } from 'prop-types';
import { SideNavigationBarProvider } from './Context/index.js';
import Menu from './Components/Menu.js';
import MenuModal from './Components/MenuModal.js';

var SideNavigationBar = function SideNavigationBar(props) {
  return /*#__PURE__*/React.createElement(SideNavigationBarProvider, props, /*#__PURE__*/React.createElement(Menu, null), /*#__PURE__*/React.createElement(MenuModal, null));
};
SideNavigationBar.propTypes = {
  accountDetails: shape({
    accountId: string.isRequired,
    accountType: string
  }).isRequired,
  aosBaseUrl: string.isRequired,
  adfsToken: string.isRequired,
  app: string.isRequired,
  translations: func,
  onTabClick: func,
  activeTab: string,
  locale: string,
  onLoadingEnd: func,
  containerName: string.isRequired
};
SideNavigationBar.defaultProps = {
  translations: null,
  activeTab: '',
  locale: '',
  onTabClick: null,
  onLoadingEnd: function onLoadingEnd() {}
};

export { SideNavigationBar as default };
